import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 延長日数
 */
export class ExtensionDays extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: number): ExtensionDays {
    return new ExtensionDays(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '延長日数';
  }

  /**
   * キー
   */
  static get key(): string {
    return 'extensionDays';
  }
}
